import FindResourceEntryInteractor from "../../core/interactor/app/crud/FindResourceEntryInteractor";
import Constants from "../common/Constants";
import { ILegalView } from "../model/LegalView";
import LegalViewMapper from "../service/LegalViewMapper";
import LegalViewParamMapper from "../service/LegalViewParamMapper";

export default class FindLegalViewInteractor {
  private resource: FindResourceEntryInteractor<ILegalView>;

  constructor({ findResourceEntry }: any) {
    this.resource = findResourceEntry;
  }

  async execute(id: number) {
    return this.resource.execute(
      Constants.endpointBasePath,
      LegalViewMapper,
      LegalViewParamMapper,
      id
    );
  }
}
